import React from 'react';

import { StyledList, StyledGridList } from './styles';

export interface Props {
  className?: string;
  children: JSX.Element | JSX.Element[];
  grid?: boolean;
  testId?: string;
}

const List = ({ className, children, grid, testId }: Props) => {
  const Component = grid ? StyledGridList : StyledList;

  return (
    <Component className={className || ''} data-testid={testId}>
      {children}
    </Component>
  );
};

export default List;
